import { createContext, useCallback, useContext, useState } from "react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import EnquiryForm from "./EnquiryForm";

const QuoteContext = createContext(null);

export const useQuote = () => useContext(QuoteContext);

export function QuoteProvider({ children }) {
    const [open, setOpen] = useState(false);
    const [formKey, setFormKey] = useState(0);

    const openQuote = useCallback(() => {
        setFormKey((k) => k + 1);
        setOpen(true);
    }, []);

    return (
        <QuoteContext.Provider value={{ openQuote }}>
            {children}
            <Dialog open={open} onOpenChange={setOpen}>
                <DialogContent
                    className="max-h-[92vh] max-w-2xl overflow-y-auto rounded-none border-slate-200 bg-white p-6 sm:p-8"
                    data-testid="quote-modal"
                >
                    <DialogHeader className="text-left">
                        <DialogTitle className="text-2xl font-bold tracking-tight text-navy">
                            Get a Quote
                        </DialogTitle>
                        <DialogDescription className="text-sm leading-relaxed text-slate-500">
                            Share your PCB requirement and our team will get back to you with pricing
                            and delivery details. You can also attach your Gerber data below.
                        </DialogDescription>
                    </DialogHeader>
                    <EnquiryForm key={formKey} />
                </DialogContent>
            </Dialog>
        </QuoteContext.Provider>
    );
}
